// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth }     from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage }   from 'firebase/storage';

const sanitize = (value) => (value ?? '').trim();

const requiredEnv = {
  REACT_APP_FIREBASE_API_KEY: sanitize(process.env.REACT_APP_FIREBASE_API_KEY),
  REACT_APP_FIREBASE_AUTH_DOMAIN: sanitize(process.env.REACT_APP_FIREBASE_AUTH_DOMAIN),
  REACT_APP_FIREBASE_PROJECT_ID: sanitize(process.env.REACT_APP_FIREBASE_PROJECT_ID),
  REACT_APP_FIREBASE_STORAGE_BUCKET: sanitize(process.env.REACT_APP_FIREBASE_STORAGE_BUCKET),
  REACT_APP_FIREBASE_APP_ID: sanitize(process.env.REACT_APP_FIREBASE_APP_ID)
};

const missingKeys = Object.entries(requiredEnv)
  .filter(([, value]) => !value)
  .map(([key]) => key);

if (missingKeys.length) {
  throw new Error(`Missing Firebase environment variables: ${missingKeys.join(', ')}. Copy .env.example to .env.local and fill your Firebase Web app config.`);
}

const placeholderKeys = Object.entries(requiredEnv)
  .filter(([, value]) =>
    value.includes('your-project-id') ||
    value.includes('your-web-api-key') ||
    value.includes('aaaaaaaa') ||
    value.includes('000000000000')
  )
  .map(([key]) => key);

if (placeholderKeys.length) {
  throw new Error(`Replace placeholder Firebase values for: ${placeholderKeys.join(', ')}. Use the Web API config from Firebase console (Project settings → Your apps → Config).`);
}

const firebaseConfig = {
  apiKey: requiredEnv.REACT_APP_FIREBASE_API_KEY,
  authDomain: requiredEnv.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: requiredEnv.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: requiredEnv.REACT_APP_FIREBASE_STORAGE_BUCKET,
  appId: requiredEnv.REACT_APP_FIREBASE_APP_ID,
  ...(process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID
    ? { messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID }
    : {}),
  ...(process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
    ? { measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID }
    : {})
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth       = getAuth(firebaseApp);
export const db         = getFirestore(firebaseApp);
export const storage    = getStorage(firebaseApp);
